import React from "react";
import { useHistory } from "react-router-dom";
import classNames from "classnames";
import styles from "./TitlePage.module.css";

export default function TitlePage({ text, isBack = false, isSmall = false }) {
  const history = useHistory();
  return (
    <div
      onClick={() => (isBack ? history.goBack() : null)}
      className={styles.wrapperTitle}
      style={{ gap: isSmall ? 12 : 16 }}
    >
      {isBack && (
        <i
          className={classNames(
            "fas fa-chevron-left",
            isSmall ? styles.iconBlackSmall : styles.iconBack
          )}
        ></i>
      )}
      <p className={isSmall ? styles.textTitleSmall : styles.textTitle}>
        {text}
      </p>
    </div>
  );
}
